import { Button, Card, Table, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useGetRecoveryEventsQuery, type RecoveryEvent } from '../../redux/api/traveler-audit';

const { Text } = Typography;

const entityLink = (label: string | null | undefined, to: string | null) => {
	if (!label) return '—';
	if (!to) return label;
	return (
		<Link to={to} target="_blank" rel="noopener noreferrer">
			{label}
		</Link>
	);
};

export function RecoveryAudit({ runId }: { runId: string }) {
	const { data, isFetching, refetch } = useGetRecoveryEventsQuery(runId, { skip: !runId });

	return (
		<Card
			title="Recovery audit"
			style={{ marginTop: 16 }}
			extra={
				<Button size="small" onClick={() => void refetch()}>
					Refresh
				</Button>
			}
		>
			<Text type="secondary">
				Original vs new vs method. Rollback on a results row restores the original job
				copy; Quality writes stay listed here.
			</Text>
			<Table<RecoveryEvent>
				style={{ marginTop: 12 }}
				size="small"
				rowKey="id"
				loading={isFetching}
				dataSource={data ?? []}
				pagination={{ pageSize: 15 }}
				scroll={{ x: 1100 }}
				columns={[
					{
						title: 'When',
						dataIndex: 'created_time',
						width: 180,
						render: (v: string) => new Date(v).toLocaleString(),
					},
					{
						title: 'Work order',
						dataIndex: 'work_order',
						width: 140,
						render: (_v, row) =>
							entityLink(
								row.work_order,
								row.order_id ? `/orders/${row.order_id}` : null
							),
					},
					{
						title: 'Line item',
						dataIndex: 'line_item_name',
						width: 180,
						render: (_v, row) =>
							entityLink(
								row.line_item_name,
								row.line_item_id ? `/orders/line-items/${row.line_item_id}` : null
							),
					},
					{
						title: 'Action',
						dataIndex: 'method_label',
						width: 240,
						render: (_v, row) => row.method_label || row.method,
					},
					{
						title: 'Field',
						dataIndex: 'field_label',
						width: 180,
						render: (_v, row) => row.field_label || row.field_key,
					},
					{
						title: 'Before',
						dataIndex: 'before_display',
						ellipsis: true,
						render: (_v, row) => row.before_display || '—',
					},
					{
						title: 'After',
						dataIndex: 'after_display',
						ellipsis: true,
						render: (_v, row) => row.after_display || '—',
					},
				]}
			/>
		</Card>
	);
}
